import cls from 'classnames';

import { radioSelectIcon } from '../../assets';
import {
  disabledSelectedIcon,
  disabledUnSelectedIcon,
  unSelectedIcon,
} from '../../assets/MetaArea';
import { Gender } from '../../types/meta';

interface ICustomRadioGroupProps {
  options: { value: Gender; label: string }[];
  value?: Gender;
  onChange?: (value: Gender) => void;
  disabled?: boolean;
  styles: Record<string, string>;
}

export function CustomRadioGroup(props: ICustomRadioGroupProps) {
  const { options, value, onChange, styles, disabled = false } = props;

  const handleClick = (value: Gender) => {
    if (disabled) return;
    onChange?.(value);
  };

  const ImageSrc = (option: { value: Gender; label: string }) => {
    if (disabled)
      return value === option.value ? disabledUnSelectedIcon.src : disabledSelectedIcon.src;
    return value === option.value ? radioSelectIcon.src : unSelectedIcon.src;
  };

  return (
    <div className={styles.customRadioGroup}>
      {options.map((option) => (
        <div
          key={option.value}
          className={cls([styles.radioItem, disabled ? styles.disabledRadioItem : ''])}
          onClick={() => handleClick(option.value)}
        >
          <img src={ImageSrc(option)} alt={option.label} width={16} height={16} />
          <span className={styles.radioLabel}>{option.label}</span>
        </div>
      ))}
    </div>
  );
}

export default CustomRadioGroup;
